import React from 'react';
import styles from './css/Error.module.css';
import { Row, Col, Layout, Menu as AntdMenu } from 'antd';
import * as CONSTANTS from '../../constants/constants';
import { Footer, FormMessage } from "./CorePageContents";

const { Content } = Layout;

export const EmergencySystemMaintenance = () => {

  return (
    <Layout>
      <Row className={styles.HeaderArea}>
        <Col span={6} className={styles.HeaderlogoArea}>
          <img
            className={styles.LogoStyle}
            src={process.env.PUBLIC_URL + '/header_logo_green.png'}
            alt="スキルマップサイト" />
        </Col>
      </Row>


      <AntdMenu className={styles.HeaderMenu}>
      </AntdMenu>

      <Content>
        <div className={styles.mainMessage}>ただいまメンテナンス中です</div>
        <br />
        <br />
        <div className={styles.subMessage}>
          平素は「スキルマップサイト」をご利用いただき、誠にありがとうございます。
          <br />
          <br />
          誠に申し訳ございませんが、ただいまメンテナンス作業のため、<br />
          サービスを一時休止しております。終了までしばらくお待ちください。
          <br />
          <br />
          詳細な情報につきましては、<a href={CONSTANTS.URL_MAINTENANCE_INFO} target="_blank" rel="noopener noreferrer" className={styles.contactFormPageLink}>メンテナンス情報ページ</a>をご覧ください。
        </div>
        <br />
        <br />
        <br />
        <FormMessage />
      </Content>
      <Footer />
    </Layout >
  );
}